import React from "react";
import { Container, Title, Text, Button, Box } from "@mantine/core";
import { useKeycloak } from "../keycloak/KeycloakContext";

const Login = () => {
  const { login, initialized } = useKeycloak();

  return (
    <Container
      fluid
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          padding: "60px 40px",
          borderRadius: "16px",
          backgroundColor: "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          maxWidth: 420,
          width: "100%",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          style={{ width: "70px", height: "70px", marginBottom: 20 }}
          fill="rgb(42, 155, 73)"
        >
          <g>
            <path
              d="M99.06,426.02v26.16h366.21v52.32H46.74v-78.47c0-43.34,35.13-78.47,78.47-78.47h287.73V242.92
              c0-46.14-44.47-93.17-86.06-127.1c-28.46-23.2-55.56-40.25-66.18-46.66c-0.05-0.05-0.13-0.08-0.18-0.1
              c-2.91-1.78-4.53-2.69-4.53-2.69S101.67,130.44,46.74,242.92c0-114.21,205.99-233.54,209.24-235.39C256,7.5,256,7.5,256,7.5
              c0.1,0.05,0.24,0.1,0.34,0.18c4.71,2.74,57.83,33.85,109.31,78.53c50.59,43.84,99.61,100.79,99.61,156.71v156.95H125.21
              C110.77,399.87,99.06,411.58,99.06,426.02z"
            />
          </g>
        </svg>

        <Title
          order={2}
          sx={{
            color: "white",
            marginBottom: 8,
            fontFamily: "Greycliff CF, sans-serif",
          }}
        >
          إرشاد التائهين
        </Title>

        <Text
          size="md"
          sx={{ color: "rgba(255, 255, 255, 0.6)", marginBottom: 30 }}
        >
          تسجيل الدخول للمتابعة
        </Text>

        <Button
          fullWidth
          size="lg"
          radius="md"
          loading={!initialized}
          onClick={login}
          sx={{
            background: "linear-gradient(135deg, rgb(42, 155, 73), rgb(32, 145, 63))",
            border: "none",
            fontWeight: 600,
            "&:hover": {
              background: "linear-gradient(135deg, rgb(52, 165, 83), rgb(42, 155, 73))",
              transform: "translateY(-2px)",
              transition: "all 0.2s ease",
            },
          }}
        >
          تسجيل الدخول
        </Button>
      </Box>
    </Container>
  );
};

export default Login;
